import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs text-foreground-500 mb-6 flex-wrap">
      <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
        <i className="ri-home-4-line"></i>
        <span className="ml-1">首页</span>
      </Link>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-600"></i>
          {item.href ? (
            <Link to={item.href} className="hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-300 whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}